/**
 *
 * RestrictedAdministratorBC Service Requests MobileGrid
 *
 */

import { ServiceRequestsManagerMobileGrid } from '../ServiceRequestsManagerView';

class RestrictedAdministratorBCServiceRequestsMobileGrid extends ServiceRequestsManagerMobileGrid {
  getFilters() {
    const { viewName } = this.props; // eslint-disable-line
    const filters = ['ServiceRequests', 'RequestsForUserDepartment'];
    if (viewName === 'active') filters.push('ActiveRequests');
    return filters;
  }
}

export default RestrictedAdministratorBCServiceRequestsMobileGrid;
